import React, { FC } from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button, CircularProgress } from '@material-ui/core';
import { Done, Error } from '@material-ui/icons';

type DeviceManageDialogProps = {
  isOpen: boolean;
  isPending: boolean;
  message: string;
  error: string;
  onClose: () => void;
};

const DeviceManageDialog: FC<DeviceManageDialogProps> = ({ isOpen, isPending, message, error, onClose }) => {
  return (
    <Dialog
      open={isOpen}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{"Handlingen sendes"}</DialogTitle>
      <DialogContent>
        {isPending && <CircularProgress />}
        {message && (
          <DialogContentText id="alert-dialog-description">
            <Done /> {message}
          </DialogContentText>
        )}
        {error && (
          <DialogContentText id="alert-dialog-description">
            <Error /> {error}
          </DialogContentText>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" autoFocus>
          Luk
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeviceManageDialog;
